<template>
  <div>
    <breadcrumbs :back="[{text:'Items and services',to:{name:'InventoryItems'}}]" :home="name"/>

    <purtrak-table name="itemtransactions" objectType="transactions" :defaultColumns="defaultColumns" :headers="headers" ref="table" show-select
                   :listEndPoint="getListData" fields="" totalField="" v-model="selected"
                   :listFilters="listFilters" :sortBy.sync="sortBy"
                   @dblclick="transaction => viewTransaction(transaction)"
                   :title="name"
                   :print-info="{pageSize:'landscape',
                                 subTitle:[filters.from?dateDisplay:'',
                                            activityTypes&&filters.activityType!=''?activityTypes.find(a=>a.value==filters.activityType).text:'',
                                            lotTracking&&filters.lot?`Lot ${filters.lot}`:'']}"
                   :download-endpoint="exportListData">
      <template v-slot:filter>
        <filter-menu include-reset @reset="filters.siteId=null;filters.activityType='';filters.lot='';filters.from=null;filters.to=null">
          <v-list-item>
            <date-range :from.sync="filters.from" :to.sync="filters.to" v-model="dateDisplay" option="All" allow-all/>
          </v-list-item>
          <v-list-item v-if="sites.length>1">
            <v-autocomplete label="Site" dense outlined :items="[{id:null,name:'All'},{divider:true},...sites]" v-model="filters.siteId" item-text="name" item-value="id"/>
          </v-list-item>
          <v-list-item v-if="activityTypes">
            <v-autocomplete label="Activity" dense outlined :items="activityTypes" v-model="filters.activityType"/>
          </v-list-item>
          <v-list-item v-if="lotTracking">
            <filter-search label="Lot" v-model="filters.lot"/>
          </v-list-item>
        </filter-menu>
        <template v-if="!$vuetify.breakpoint.mobile">
          <v-chip v-show="filters.from!=null" close small class="ml-1" @click:close="filters.from=null;filters.to=null">{{dateDisplay}}</v-chip>
          <v-chip v-show="filters.siteId!=null" close small class="ml-1" @click:close="filters.siteId=null">{{siteName}}</v-chip>
          <v-chip v-if="activityTypes" v-show="filters.activityType!=''" close small class="ml-1" @click:close="filters.activityType=''">{{activityTypes.find(a=>a.value==filters.activityType).text}}</v-chip>
          <v-chip v-if="lotTracking" v-show="filters.lot" close small class="ml-1" @click:close="filters.lot=''">Lot {{filters.lot}}</v-chip>
        </template>
      </template>

      <template v-slot:footer v-if="selected.length">
        <v-icon style="position: absolute" class="mt-3 ml-3">mdi-arrow-up-left</v-icon>
        <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" @click="deleteMultiple=true;showDelete=true">Batch delete</v-btn>
      </template>
      <template v-slot:item.date="{value}">
        {{value | formatDateTime}}
      </template>
      <template v-slot:item.description="{item,printing}">
        {{item.description}}
        <div v-if="!printing" class="text-caption">{{item.comments}}</div>
      </template>
      <template v-slot:header.quantity>
        {{trackUnits || '' | uppercase}}
      </template>
      <template v-slot:item.quantity="{value,printing}">
        <template v-if="printing">{{value | number(precision)}}</template>
        <span :class="{'red--text':value<0}">
          {{value | number(precision)}}
        </span>
      </template>
      <template v-slot:item.value="{value,printing}">
        <template v-if="printing">{{value | currency}}</template>
        <span :class="{'red--text':value<0}">
          {{value | currency}}
        </span>
      </template>
      <template v-slot:item.quantityBalance="{item}">
        {{item.quantityBalance | number(item.precision)}}
      </template>
      <template v-slot:item.valueBalance="{value}">
        {{value | currency}}
      </template>
      <template v-slot:item.lot="{item:transactionItem,printing}">
        <template v-if="printing">{{transactionItem.lot}}</template>
        <v-hover v-else-if="transactionItem.lot" v-slot="{hover}">
          <a @click.stop="$router.push({name:'ReportsView',params:{back:[{text:'Items and services',to:{name:'InventoryItems'}},{text:name,to:{name:'InventoryItemsTransactions',params:{itemId}}}]},query:{to:'reports/inventory/ReportsLot',id:transactionItem.refId,lot:transactionItem.lot,forward:0}})"
             :class="{'text-decoration-underline':hover}">{{transactionItem.lot}}</a>
        </v-hover>
      </template>
      <template v-slot:item.action="{item:transactionItem}">
        <v-menu :nudge-width="150" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small v-on="on" v-if="$vuetify.breakpoint.mobile" outlined>Transaction operations</v-btn>
            <v-btn small icon v-on="on" v-else><v-icon small>mdi-dots-vertical</v-icon></v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="viewTransaction(transactionItem)"><v-list-item-title>Details</v-list-item-title></v-list-item>
            <v-list-item v-if="lotTracking" :to="{name:'ReportsView',params:{back:[{text:'Items and services',to:{name:'InventoryItems'}},{text:name,to:{name:'InventoryItemsTransactions',params:{itemId}}}]},query:{to:'reports/inventory/ReportsLot',id:transactionItem.refId,lot:transactionItem.lot,forward:0}}"><v-list-item-title>Trace lot</v-list-item-title></v-list-item>
            <v-list-item v-if="audit" :to="{name:'Audit',query:{entityId:transactionItem.refId}}"><v-list-item-title>Audit history</v-list-item-title></v-list-item>
            <template v-if="!readOnly">
              <v-divider/>
              <v-list-item @click="transaction=transactionItem;deleteMultiple=false;showDelete=true"><v-list-item-title>Delete transaction</v-list-item-title></v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:body.append="{headers,printing}" v-if="!$vuetify.breakpoint.mobile">
        <tr :class="darkMode ? 'total-row-dark' : 'total-row'">
          <template v-for="header of headers">
            <td class="text-right" v-if="header.value==='quantity'">
              {{totals.totalQuantity | number(precision)}}
            </td>
            <td class="text-right" v-else-if="header.value==='value' && values">
              {{totals.totalValue | currency}}
            </td>
            <td v-else-if="!printing || header.print === undefined || header.print"/>
          </template>
        </tr>
      </template>
    </purtrak-table>

    <delete-object v-model="showDelete" :name="deleteMultiple?'ALL selected transactions':'this transaction'" @delete="performDelete(transaction.refId, 'refId')"/>
  </div>
</template>

<script>
import performDelete from '@/mixins/performDelete'
import viewTransaction from '@/mixins/viewTransaction'

export default {
  name: 'InventoryItemsTransactions',
  mixins: [viewTransaction,performDelete],
  props: {
    itemId: {type:String, required:true}
  },
  data() {
    return {
      filters: {
        from: null,
        to: null,
        siteId: null,
        activityType: '',
        lot: ''
      },
      sortBy: '',
      name: '',
      trackUnits: '',
      precision: 0,
      lotTracking: false,
      dateDisplay: '',
      activityTypes: [{text:'All',value:''},{divider:true},{text:'Initial',value:'ItemTransactionInitial'},{text:'Adjust inventory',value:'ItemTransactionAdjustInventory'},
                      {text:'Mash',value:'Mash'},{text:'Distillation',value:'Distillation'},{text:'Blending',value:'Blend'},{text:'Bottling',value:'Bottling'},
                      {text:'Transfer site',value:'ItemTransactionTransferSite'},{text:'Inventory receipt',value:'Receipt'},{text:'Assemble',value:'Assembly'},
                      {text:'Denature',value:'ExciseVesselTransactionDenature'}],
      transaction: {},
      showDelete: false,
      deleteMultiple: false,
      totals: {totalValue: 0, totalQuantity: 0},
      defaultColumns: [{ value: 'date', visible:true},
                       { value: 'siteName', visible:true},
                       { value: 'description', visible:true},
                       { value: 'comments', visible:false},
                       { value: 'lot', visible:false},
                       { value: 'value', visible:false},
                       { value: 'valueBalance', visible:false},
                       { value: 'quantity', visible:true},
                       { value: 'quantityBalance', visible:false}],
      headers: [{ text: 'DATE', value: 'date', width:'15%',sortable:true},
                { text: 'SITE', value: 'siteName', width:'15%',sortable:true, omit:() => this.sites.length <= 1},
                { text: 'ACTIVITY', value: 'description', width:'30%',sortable:false},
                { text: 'COMMENTS', value: 'comments', width:'30%',sortable:false},
                { text: 'LOT', value: 'lot', width:'10%',sortable:true},
                { text: 'QUANTITY', value: 'quantity', width:'15%',sortable:true,align:'right'},
                { text: 'BALANCE', value: 'quantityBalance', width:'15%',sortable:false,align:'right', omit:() => !this.showBalances},
                { text: 'VALUE', value: 'value', width:'15%',sortable:true,align:'right', omit:() => !this.values},
                { text: '$ BALANCE', value: 'valueBalance', width:'15%',sortable:false,align:'right', omit:() => !this.values || !this.showBalances}]
    }
  },
  computed: {
    showBalances() {
      return this.filters.activityType === '' && this.filters.siteId == null && this.filters.lot == '' &&
             (this.sortBy === 'date' || this.sortBy === '');
    },
    sites() {
      return this.$store.getters.sites();
    },
    siteName() {
      return this.sites.find(site => site.id === this.filters.siteId)?.name;
    },
    company() {
      return this.$store.getters.company;
    },
    values() {
      return this.company.permissions.includes('values');
    },
    readOnly() {
      return !this.company.permissions.includes('production.write');
    },
    audit() {
      return this.company.allowAudit && this.company.permissions.includes('audit');
    },
    listFilters() {
      const filters = [];
      if (this.filters.from)
        filters.push({field:'date', comparator:'ge', value:`${this.filters.from} 00:00:00`});
      if (this.filters.to)
        filters.push({field:'date', comparator:'le', value:`${this.filters.to} 23:59:59`});
      if (this.filters.siteId)
        filters.push({field:'siteId', comparator:'eq', value:this.filters.siteId});
      if (this.filters.activityType !== '')
        filters.push({field:'refType', comparator:'eq', value:this.filters.activityType});

      if (this.filters.lot)
        filters.push({field:'lot', comparator:'contains', value:this.filters.lot});

      return filters;
    }
  },
  methods: {
    async getListData(after, cursor, pageSize, filters, parameters, options) {
      const results = await this.$apiCall(`query InventoryItemsTransactions($id:ID!, $after: String, $first:Int, $before: String, $last: Int, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                             item(id:$id) {
                                                name,trackUnits,precision,lotTracking
                                                transactions2(first:$first, after:$after, last:$last, before:$before, filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters) {
                                                  totalCount
                                                  totalQuantity, totalValue
                                                  pageInfo {
                                                    hasPreviousPage
                                                    hasNextPage
                                                    startCursor
                                                    endCursor
                                                  }
                                                  edges {
                                                    cursor
                                                    node {
                                                      id,date,refType,refId,description,comments,siteId,siteName,lot,quantity,value,quantityBalance,valueBalance
                                                    }
                                                  }
                                                }
                                              }
                                            }`,
                                           {id:this.itemId,
                                            after:after?cursor:null, first:after?pageSize:null,
                                            before:!after?cursor:null, last:!after?pageSize:null,
                                            filters, parameters,
                                            sortKey:options.sortBy[0], reverse:options.sortDesc[0]});

      this.name = `${results.data.item.name}: Transactions`;
      this.trackUnits = results.data.item.trackUnits;
      this.precision = results.data.item.precision;
      this.lotTracking = results.data.item.lotTracking;
      const transactions = results.data.item.transactions2;
      Object.assign(this.totals, {totalQuantity:transactions.totalQuantity, totalValue:transactions.totalValue});
      return transactions;
    },

    async exportListData(filters, parameters, options) {
      const results = await this.$apiCall(`query InventoryItemsTransactions($id:ID!, $filters:[FilterInput], $sortKey: String, $reverse: Boolean, $parameters: [ParameterInput]) {
                                              item(id:$id) {
                                                transactionsExportCSV(filters:$filters, sortKey:$sortKey, reverse:$reverse, parameters:$parameters)
                                              }
                                            }`,
                                          {id:this.itemId,
                                          filters, parameters,
                                           sortKey:options.sortBy[0], reverse:options.sortDesc[0]});
      if (!results.error)
        return results.data.item.transactionsExportCSV;
    }
  }
}
</script>